import { Component } from '@angular/core';
import { LoadingService } from '../../service/loading/loading.service';

// The landing pages' frame: the top nav, the page and the footer. No decorative circuit lines on any page
// (owner 2026-10-12); the home draws its own board (app-hero-circuit).
@Component( {
  selector: 'app-landing-layout',
  templateUrl: './landing-layout.component.html',
  styleUrls: [ './landing-layout.component.scss' ]
} )
export class LandingLayoutComponent {

  loading = false;

  constructor( private loadingService: LoadingService ) {
    this.loadingService.sharedLoading.subscribe( loading => this.loading = loading );
  }
}
